module.exports = __webpack_public_path__ + "static/media/background.3d1d8fb5.jpg";